import { render, staticRenderFns } from "./RollCard.vue?vue&type=template&id=2e1a545d&scoped=true&"
import script from "./RollCard.vue?vue&type=script&lang=js&"
export * from "./RollCard.vue?vue&type=script&lang=js&"
import style0 from "./RollCard.vue?vue&type=style&index=0&id=2e1a545d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1a545d",
  null
  
)

export default component.exports